<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">username</th>
            <td>{{ item['username'] }}</td>
          </tr>
          <!-- <tr>
            <th scope="row">salt</th>
            <td>{{ item['salt'] }}</td>
          </tr>
          <tr>
            <th scope="row">password</th>
            <td>{{ item['password'] }}</td>
          </tr>
          <tr>
            <th scope="row">roles</th>
            <td>{{ item['roles'] }}</td>
          </tr> -->
          <tr>
            <th scope="row">Testimonials</th>
            <td v-if="item['testimonials'] != ''">
               <router-link                
                :to="{name: 'TestimonialList'}">
                {{ item['testimonial'].length }}
              </router-link></td>
          </tr>
          <tr>
            <th scope="row">Email</th>
            <td>{{ item['email'] }}</td>
          </tr>
          <!-- <tr>
            <th scope="row">notificationToken</th>
            <td>{{ item['notificationToken'] }}</td>
          </tr> -->
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'UserList' }"
      class="btn btn-primary">
      Back to list
    </router-link>
    <!-- <router-link
      v-if="item"
      :to="{ name: 'UserUpdate', params: { id: item['@id'] } }"
      class="btn btn-warning">
      Edit
    </router-link> -->
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields('user/del', {
      deleteError: 'error',
    }),
    ...mapFields('user/show', {
      error: 'error',
      isLoading: 'isLoading',
      item: 'retrieved',
    }),
  },

  beforeDestroy () {
    this.reset();
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },

  methods: {
    ...mapActions({
      del: 'user/del/del',
      reset: 'user/show/reset',
      retrieve: 'user/show/retrieve',
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'UserList' }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/user/Show.vue